import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9a5f958e = () => interopDefault(import('../pages/booking.vue' /* webpackChunkName: "pages/booking" */))
const _a0e61fa2 = () => interopDefault(import('../pages/browser-not-supported.vue' /* webpackChunkName: "pages/browser-not-supported" */))
const _00106406 = () => interopDefault(import('../pages/demo-template-routing.vue' /* webpackChunkName: "pages/demo-template-routing" */))
const _53628177 = () => interopDefault(import('../pages/duplicate-booking.vue' /* webpackChunkName: "pages/duplicate-booking" */))
const _8140ae0c = () => interopDefault(import('../pages/event.vue' /* webpackChunkName: "pages/event" */))
const _67846911 = () => interopDefault(import('../pages/no-valid-users-page.vue' /* webpackChunkName: "pages/no-valid-users-page" */))
const _282dd768 = () => interopDefault(import('../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/booking",
    component: _9a5f958e,
    name: "booking"
  }, {
    path: "/browser-not-supported",
    component: _a0e61fa2,
    name: "browser-not-supported"
  }, {
    path: "/demo-template-routing",
    component: _00106406,
    name: "demo-template-routing"
  }, {
    path: "/duplicate-booking",
    component: _53628177,
    name: "duplicate-booking"
  }, {
    path: "/event",
    component: _8140ae0c,
    name: "event"
  }, {
    path: "/no-valid-users-page",
    component: _67846911,
    name: "no-valid-users-page"
  }, {
    path: "/not-found",
    component: _282dd768,
    name: "not-found"
  }, {
    path: "/book/browser-not-supported/",
    component: _a0e61fa2,
    props: false,
    name: "unsupported-browser"
  }, {
    path: "/book/duplicate-booking/:demoToken",
    component: _53628177,
    props: true,
    name: "duplicate-booking"
  }, {
    path: "/book/:slug/:event_type_slug",
    component: _9a5f958e,
    props: true,
    name: "booking"
  }, {
    path: "/select/:slug/:demoTemplateRoutingSlug/old",
    component: _00106406,
    props: true,
    name: "demo-template-routing-select"
  }, {
    path: "/select/:slug/:demoTemplateRoutingSlug",
    component: _00106406,
    props: true,
    name: "demo-template-routing-select"
  }, {
    path: "/select/not-found/:slug/:demoTemplateRoutingSlug",
    component: _282dd768,
    props: true,
    name: "selectPageNotFound"
  }, {
    path: "/book/:slug/:event_type_slug/:date/:time/old",
    component: _8140ae0c,
    props: true,
    name: "event"
  }, {
    path: "/book/:slug/:event_type_slug/:date/:time",
    component: _8140ae0c,
    props: true,
    name: "event"
  }, {
    path: "/book/not-found/:slug/:event_type_slug",
    component: _282dd768,
    name: "pageNotFound"
  }, {
    path: "/book/no-valid-users/:slug/:event_type_slug",
    component: _67846911,
    name: "no-valid-users"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
